var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcNewBadge = function SvgIcNewBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D80C18",
    d: "M5.276 7.535h1.416V.465H5.037V4.61h-.063L2.142.465H.702v7.07h1.66v-4.15h.053zM7.771.465h4.898v1.357H9.432v1.5h2.983v1.352H9.432v1.504h3.237v1.357H7.77zM13.357.465h1.832l1.088 4.682h.064L17.566.465h1.519l1.23 4.697h.059L21.468.465h1.83l-2.045 7.07h-1.616L18.352 3.18h-.048l-1.29 4.355h-1.606z"
  })));
};
export default SvgIcNewBadge;